import { ComponentType } from 'react';

import { CandidateLoginFeature } from './candidate-login';
import { EmployerLoginFeature } from './employer-login';

type AuthRouteProps = {
   captchaKey: string | null;
};

export type AuthRoute = {
   path: string;
   Component: ComponentType<AuthRouteProps>;
};

export const AUTH_ROUTES: AuthRoute[] = [
   {
      path: '/auth/candidate-login',
      Component: CandidateLoginFeature,
   },
   {
      path: '/auth/employer-login',
      Component: EmployerLoginFeature,
   },
];
